var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.77872 14.9283H2.90311L13.0465 4.78369L11.9233 3.6342L1.77872 13.7776V14.9283ZM15.2953 4.10478L12.6286 1.38541L13.6739 0.313726C13.9007 0.104575 14.1579 0 14.4457 0C14.7335 0 14.9907 0.113359 15.2175 0.340078L16.3933 1.48957C16.5849 1.69872 16.6723 1.96476 16.6556 2.28769C16.638 2.60978 16.5334 2.8754 16.3419 3.08455L15.2953 4.10478ZM1.5704 16C1.32612 16 1.12115 15.9172 0.955502 15.7515C0.789855 15.5859 0.707031 15.3809 0.707031 15.1366V13.6471C0.707031 13.5425 0.7246 13.4421 0.759737 13.3459C0.794038 13.2505 0.85511 13.1593 0.942953 13.0723L11.9233 2.11702L14.6151 4.78369L3.60962 15.7641C3.53934 15.8344 3.45652 15.8912 3.36115 15.9347C3.26494 15.9782 3.16455 16 3.05997 16H1.5704ZM12.4981 4.20894L11.9233 3.6342L13.0465 4.78369L12.4981 4.20894Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.7ab4ba8d6e4801abc8f3775a3a74192e.svg";
export { ForwardRef as ReactComponent };